/* 🤖 this file was generated by svg-to-ts*/
export const icoViewDisabled: {
  name: 'view-disabled';
  data: string;
} = {
  name: 'view-disabled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 14a1 1 0 01.993.883L13 15v3l-.007.117a1 1 0 01-1.986 0L11 18v-3l.007-.117A1 1 0 0112 14zm-6.445-1.832a1 1 0 01.336 1.286l-.059.1-2 3a1 1 0 01-1.723-1.008l.059-.1 2-3a1 1 0 011.387-.278zm12.89 0a1 1 0 011.317.184l.07.093 2 3 .06.101a1 1 0 01-1.654 1.102l-.07-.093-2-3-.06-.101a1 1 0 01.337-1.286zM3.707 6.293C6.192 8.778 8.942 10 12 10c3.058 0 5.808-1.222 8.293-3.707a1 1 0 111.414 1.414C18.86 10.555 15.608 12 12 12c-3.608 0-6.859-1.445-9.707-4.293a1 1 0 111.414-1.414z" fill="#909090"/></svg>`
};
